import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from 'app/api'
import { Pin } from 'app/common/components/Cafeteria/dataTypes/customer/settings/pin'
import {
  POST_CAFETERIA_CUSTOMER_SETTINGS_PIN,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cafeteria/customer/settings/pin/post'

export function useCustomerPinGenerate(customerID: string) {
  const { t } = useTranslation('cafeteria')

  const [pin, setPin] = useState<Pin | null>(null)

  const generate = useCallback(async () => {
    const res = await api.request(POST_CAFETERIA_CUSTOMER_SETTINGS_PIN, {
      error: t('settings_pin_generate_error', 'Не удалось сгенерировать пин-код') as string,
      params: {
        customerID,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      setPin(res)
    }

    return res
  }, [customerID, t])

  return {
    pin,
    generate,
  }
}
